var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linear / Messages, Conversation  /  Letter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.6665 9.99967C1.6665 6.85698 1.6665 5.28563 2.64281 4.30932C3.61913 3.33301 5.19047 3.33301 8.33317 3.33301H11.6665C14.8092 3.33301 16.3805 3.33301 17.3569 4.30932C18.3332 5.28563 18.3332 6.85698 18.3332 9.99967C18.3332 13.1424 18.3332 14.7137 17.3569 15.69C16.3805 16.6663 14.8092 16.6663 11.6665 16.6663H8.33317C5.19047 16.6663 3.61913 16.6663 2.64281 15.69C1.6665 14.7137 1.6665 13.1424 1.6665 9.99967Z",
    stroke: "#031D33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5 6.66699L6.79908 8.16623C8.32961 9.44167 9.09488 10.0794 10 10.0794C10.9051 10.0794 11.6704 9.44167 13.2009 8.16622L15 6.66699",
    stroke: "#031D33",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.13813926d86603af4b120657083bad6f.svg";
export { ForwardRef as ReactComponent };